var _path, _path2, _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOnline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 15,
    viewBox: "0 0 15 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.02173 1.68584C7.39469 0.680841 10.2088 1.16834 12.095 3.02834C14.6048 5.50334 14.6048 9.50834 12.095 11.9758C10.2088 13.8358 7.38708 14.3233 5.02173 13.3183C7.59243 14.7058 10.8476 14.2933 12.9848 12.1858C15.6164 9.59834 15.6164 5.39834 12.9924 2.81834C10.8553 0.703341 7.59243 0.298341 5.02173 1.68584Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M11.4256 13.9857C8.71035 15.2307 5.43232 14.6982 3.24951 12.5532C0.420211 9.76317 0.420211 5.23317 3.24951 2.44317C5.42472 0.298173 8.71035 -0.234327 11.4256 1.01067C8.48979 -0.669326 4.70218 -0.241827 2.23035 2.19567C-0.743451 5.12817 -0.743451 9.87567 2.23035 12.8007C4.70218 15.2382 8.48979 15.6657 11.4256 13.9857Z"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 7.5016,
    cy: 7.49836,
    r: 6.13636
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOnline);
export default __webpack_public_path__ + "static/media/online.b5feeb9cf768875faac35247cce450ee.svg";
export { ForwardRef as ReactComponent };